var _rect, _path, _circle, _rect2, _path2, _path3, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3.89655,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.67439L4 22.8975C4 24.1377 5.0054 25.1431 6.24561 25.1431L23.4687 25.1431C24.7089 25.1431 25.7143 24.1377 25.7143 22.8975L25.7143 5.67439C25.7143 4.43417 24.7089 3.42878 23.4687 3.42878L6.24561 3.42878C5.0054 3.42878 4 4.43418 4 5.67439Z",
    fill: "#6B57FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4561,
    cy: 23.5788,
    r: 6.17544,
    fill: "#FD8107"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.14513,
    height: 8.16168,
    rx: 0.572566,
    transform: "matrix(0.723861 -0.689946 0.723861 0.689946 19.0878 21.9971)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7487 22.7381C23.9094 21.4602 23.1912 20.4307 22.5947 19.6489C22.1801 20.2111 21.7738 20.7795 21.3759 21.3539L25.1669 24.9672C25.3513 24.2743 25.252 23.5068 24.8301 22.8625L24.7487 22.7381ZM24.6077 26.0145L20.7235 22.3122C20.6017 22.4944 20.4807 22.677 20.3606 22.8603L20.3236 22.9186C20.0702 23.3292 19.9354 23.8048 19.9354 24.2906C19.9354 25.7146 21.0691 26.8691 22.4677 26.8691H22.7243C23.224 26.8691 23.7125 26.7185 24.1282 26.4363C24.3088 26.3137 24.469 26.1716 24.6077 26.0145Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.763 9.78222C18.7415 9.78222 17.1119 8.1635 17.1119 6.17529H14.3868V16.5298C14.3868 17.7175 13.4073 18.6852 12.2051 18.6852C11.0028 18.6852 10.0233 17.7175 10.0233 16.5298C10.0233 15.3422 11.0028 14.3745 12.2051 14.3745C12.4633 14.3745 12.7305 14.4184 12.9709 14.5152V11.7528C12.7127 11.7088 12.4544 11.6913 12.1872 11.6913C9.48895 11.6913 7.29825 13.8466 7.29825 16.5122C7.29825 19.1778 9.48895 21.3332 12.1872 21.3332C14.8855 21.3332 17.0762 19.1778 17.0762 16.5122V11.2954C18.1182 12.0256 19.3827 12.4478 20.7541 12.4478H20.7719V9.78222H20.763Z",
    fill: "#FFD43A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.166667,
    y: 0.166667,
    width: 31.6667,
    height: 31.6667,
    rx: 3.72989,
    stroke: "#D3D2D6",
    strokeOpacity: 0.2,
    strokeWidth: 0.333333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.073dbfde.svg";
export { ForwardRef as ReactComponent };